import { render, staticRenderFns } from "./personalPage.vue?vue&type=template&id=365b770a&scoped=true&"
import script from "./personalPage.vue?vue&type=script&lang=js&"
export * from "./personalPage.vue?vue&type=script&lang=js&"
import style0 from "./personalPage.vue?vue&type=style&index=0&id=365b770a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b770a",
  null
  
)

export default component.exports